var cardPreviewStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return Object.assign({
      margin: v.previewMargin
    }, p.horizontal && {
      margin: v.previewMarginHorizontal
    }, {}, p.fitted && {
      margin: v.fittedPreviewMargin
    });
  }
};
export default cardPreviewStyles;
//# sourceMappingURL=cardPreviewStyles.js.map
